// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_e442f2f6"};